import { type NavigationService } from '@vse/MachineLogicServices';
import { type NavigateFunction } from 'react-router-dom';

let navigate: NavigateFunction;

export const setNavigate = (routerNavigate: NavigateFunction): void => {
  navigate = routerNavigate;
};

export const navigationService: NavigationService = {
  navigateToMachineConfig: () => {
    if (navigate === undefined) {
      throw new Error("The navigation service is trying to navigate before its navigation function was set. Make sure to call 'setNavigate' before attempting to navigate.");
    }
    else {
      navigate('/machine-config');
    }
  },
};
